import { render, staticRenderFns } from "./DownPaymentItemsGrid.vue?vue&type=template&id=1fa86fc9&scoped=true&"
import script from "./DownPaymentItemsGrid.vue?vue&type=script&lang=ts&"
export * from "./DownPaymentItemsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./DownPaymentItemsGrid.vue?vue&type=style&index=0&id=1fa86fc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa86fc9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
